<template>
  <label>
    <span>{{ label }}</span>
    <textarea v-model="valueProxy"></textarea>
  </label>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: () => '',
    },
    label: {
      type: String,
      default: () => '',
    },
  },
  computed: {
    valueProxy: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
<style lang="scss" scoped>
label {
  position: relative;
  color: var(--va-primary);
  font-size: 0.625rem;
  line-height: 1.2;
  font-weight: bold;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: top left;
  max-width: 100%;
  display: flex;
}

span {
  position: absolute;
  top: 10px;
  left: 10px;
}

textarea {
  border-radius: 0.375rem;
  flex-grow: 1;
  height: auto;
  min-height: 150px;
  resize: vertical;
  max-height: 200px;
  padding: 20px;
  padding-top: 30px;
  background: var(--va-background);
  color: var(--va-textColor);
  font-size: 20px;
}
</style>
